import React from 'react'
import { keyBy } from 'lodash'
import { graphql, useFragment } from 'react-relay/hooks'
import { FlexRow } from 'elements'
import ReportPeriodCard from './cards/ReportPeriodCard'
import AnomaliesCard from './cards/AnomaliesCard'
import TextCard from './cards/TextCard'
import { FormattedNumber } from 'react-intl'

type Props = { company: any }

export default function CompanyDashboard(props: Props) {
  const { company } = props

  const data = useFragment(
    graphql`
      fragment CompanyDashboard_company on Company {
        reportMetrics {
          name
          value
        }
        latestReport: reports(first: 1, orderBy: [PERIOD_END_DESC, CREATED_AT_DESC]) {
          edges {
            node {
              periodStart
              periodEnd
            }
          }
        }
      }
    `,
    company,
  )

  if (!data) {
    return null
  }

  const { reportMetrics, latestReport } = data
  const report = latestReport?.edges?.[0]?.node

  if (!reportMetrics?.length || !report) {
    return null
  }

  const keyedMetrics = keyBy(reportMetrics, 'name')

  return (
    <FlexRow justifyContent="space-around" pt="xlarge" pb="xxxlarge">
      <ReportPeriodCard periodStart={report.periodStart} periodEnd={report.periodEnd} />
      <AnomaliesCard
        anomalyCountHigh={keyedMetrics.anomalyCountHigh.value}
        anomalyCountMedium={keyedMetrics.anomalyCountMedium.value}
        anomalyCountLow={keyedMetrics.anomalyCountLow.value}
      />
      <TextCard
        value={<FormattedNumber value={keyedMetrics.transactionCount.value} />}
        text="Total transactions"
      />
    </FlexRow>
  )
}
